export enum ProjectDocSignerRoleCode {
    Contractor = 1,
    Designer = 2,
    SkContractor = 3,
    ActParty = 4,
    Other = 5,
}